import React from "react";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";

const RecaptchaWrapper = ({ children }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const getRecaptchaToken = async (action = "default_action") => {
    return await executeRecaptcha(action);
  };

  return children(getRecaptchaToken);
};

const withRecaptcha = (Component) => (props) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_CAPTCHA_V3_SITE_KEY}
    >
      <RecaptchaWrapper>
        {(getRecaptchaToken) => (
          <Component {...props} getRecaptchaToken={getRecaptchaToken} />
        )}
      </RecaptchaWrapper>
    </GoogleReCaptchaProvider>
  );
};

export default withRecaptcha;
